export default class Rules {
  
  constructor( api, isRoot, isInterface ) {
    this.api = api
    this.connect = isInterface ? api : api.child( 'rule' )
    if ( isRoot ) {
      this.listRuleForMessageType = listRuleForMessageType
    }
  }

  // List all enums
  list( options ) {
    return this.connect.get( options )
  }

  // add enum
  create( data, options ) {
    return this.connect.post( data, options )
  }

  delete( opts, query ) {
    return this.connect.delete( opts, query )
  }
}

function listRuleForMessageType( opts ) {
  return this.api.child( 'rulesForMessage' ).get( opts )
}
